import {Directive, ElementRef, forwardRef, HostListener, Input, Renderer2} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

@Directive({
  selector: '[dateInputProcessor]',
  standalone: true,
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DateInputConverterDirective),
    multi: true
  }]
})
/**
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export class DateInputConverterDirective implements ControlValueAccessor {

  /**
   * Specifies the value that is being passed through the reactive form
   *
   * @usageNotes
   * ### string | timestamp -> new Date(value)
   * ### epoch -> new Date(value * 1000)
   *
   * @author Carlos Duardo <carlos.duardo@qualud.com>
   */
  @Input() valueFrom: 'string' | 'date' | 'epoch'| 'timestamp' = 'date';

  @HostListener('blur', []) onTouched: any = () => { };
  @HostListener('input', ['$event']) onChange: any = () => { };

  private valueType: 'value' | 'valueAsDate' = 'valueAsDate';

  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  registerOnTouched(fn: () => void) { this.onTouched = fn; }

  registerOnChange(fn: (value: any) => void) {
    this.onChange = (event: any) => fn(event.target[this.valueType])
  }

  writeValue(value: any) {

    if (undefined === value || null === value || '' === value) {
      return;
    }

    if ('date' !== this.valueFrom) {

      switch (typeof value) {
        case 'number':
          value = new Date(value * ('epoch' === this.valueFrom ? 1000 : 1))
          break;
        case 'string':
          value = new Date(value)
          break;
        default:
          throw new Error('Invalid date value')
      }

    }

    this.renderer.setProperty(this.elementRef.nativeElement, this.valueType, value);
  }

}
